module.exports = __webpack_public_path__ + "static/media/poste_20.281066e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_20.jpg
// module id = 249
// module chunks = 0